import { FlexCrate, Text } from '@perch-labs/shrike';
import { PieChart, PieChartProps } from 'components/pie-chart';
import { copyFor } from 'config';
import { money } from 'utils/format';
import {
  LegendContainer,
  LegendSquare,
  PieWrapper,
  TextContent,
  TextHeader,
  TextTotal,
  pieColors,
} from '../pie-carousel.style';

type YourBillWithArcadiaProps = {
  options: PieChartProps['options'];
  savings: { percentage: number; total: number };
  solar: { percentage: number; total: number };
  utility: { percentage: number; total: number };
  utilityNames: string;
  total: number;
};

const getCopy = copyFor('billing.statement.pieCharts.yourBillWithArcadia');

export const YourBillWithArcadia: React.FC<YourBillWithArcadiaProps> = ({
  options,
  savings,
  solar,
  utility,
  utilityNames,
  total,
}) => (
  <PieWrapper>
    <TextHeader>{getCopy('header')}</TextHeader>
    <PieChart
      data={{
        datasets: [
          {
            data: [savings.percentage, utility.percentage, solar.percentage],
            backgroundColor: [
              pieColors.savings,
              pieColors.utility,
              pieColors.solar,
            ],
            borderWidth: [0, 0, 0],
            offset: [60, 0, 0],
            rotation: 200,
          },
        ],
      }}
      height="200px"
      width="200px"
      options={options}
    />
    <TextTotal>{money(total)}</TextTotal>
    <LegendContainer>
      {[
        [
          pieColors.utility,
          getCopy('legend.utility', {
            utility: utilityNames,
            total: money(utility.total),
          }),
        ],
        [
          pieColors.solar,
          getCopy('legend.solar', {
            total: money(solar.total),
          }),
        ],
        [
          pieColors.savings,
          getCopy('legend.savings', {
            total: money(savings.total),
          }),
        ],
      ].map(([color, copy]) => (
        <FlexCrate alignItems="center" margin="2px 0" key={color}>
          <LegendSquare color={color} />
          <Text>{copy}</Text>
        </FlexCrate>
      ))}
    </LegendContainer>
    <TextContent>{getCopy('content')}</TextContent>
  </PieWrapper>
);
